<script setup lang="ts">
import AppButton from "@/components/ui-kit/button/AppButton.vue";

const emit = defineEmits<{
	(e: 'cancel'): void,
	(e: 'confirm'): void,
}>()
</script>

<template>
	<div class="delete-job-confirm">
		<div class="delete-job-confirm__title">
			Удалить работу?
		</div>
		<div class="delete-job-confirm__description">
			Вы собираетесь удалить работу без возможности восстановления
		</div>
		<div class="delete-job-confirm__actions">
			<app-button
				class="delete-job-confirm__actions-button"
				type="secondary"
				label="Отмена"
				@click="emit('cancel')"
			/>
			<app-button
				class="delete-job-confirm__actions-button"
				label="Подтвердить"
				@click="emit('confirm')"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.delete-job-confirm {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 12px;
	gap: 8px;

	&__title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #4D4D4D;
	}

	&__description {
		font-size: 14px;
		line-height: 18px;
		color: #4D4D4D;
		text-align: center;
	}

	&__actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		&-button {
			flex: 1;
		}
	}
}
</style>
